// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"36c922db","239":"c0401dae","453":"aa12bc76","732":"14803632","751":"f46f15a5","857":"817f9776","977":"38410c34"}[chunkId] + ".chunk.js";
};